import React from "react";
import { Form, Button } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import LoadingSpinner from "./LoadingSpinner";

export const EmailField = ({
  value,
  onChange,
  placeholder = "Email address",
}) => (
  <Form.Group className="mb-3">
    <Form.Control
      type="email"
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        // Normalize email to lowercase to prevent duplicate accounts
        const normalizedEmail = e.target.value.toLowerCase();
        onChange({ ...e, target: { ...e.target, value: normalizedEmail } });
      }}
      required
      className="form-field-focus"
    />
  </Form.Group>
);

export const PasswordField = ({
  value,
  onChange,
  placeholder = "Password",
  showPassword,
  onToggleShow,
}) => (
  <Form.Group className="mb-3" style={{ position: "relative" }}>
    <Form.Control
      type={showPassword ? "text" : "password"}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required
      className="form-field-focus"
      style={{ paddingRight: "40px" }}
    />
    <Button
      variant="link"
      onClick={onToggleShow}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "none",
        color: "#6c757d",
        padding: "0",
        zIndex: 10,
      }}
    >
      {showPassword ? <BsEye /> : <BsEyeSlash />}
    </Button>
  </Form.Group>
);

export const VerificationCodeField = ({ value, onChange }) => (
  <Form.Group className="mb-3">
    <Form.Control
      type="text"
      inputMode="numeric"
      placeholder="Enter 6-digit verification code"
      value={value}
      onChange={(e) => {
        const numericValue = e.target.value.replace(/\D/g, '').slice(0, 6);
        onChange(numericValue);
      }}
      maxLength="6"
      className="form-field-focus"
    />
  </Form.Group>
);

export const SubmitButton = ({
  isLoading,
  loadingText,
  defaultText,
  variant = "primary",
}) => (
  <Button
    variant={variant}
    type="submit"
    className="w-100 mb-3 btn-animate d-flex align-items-center justify-content-center gap-2"
    disabled={isLoading}
  >
    {isLoading ? (
      <>
        <LoadingSpinner size="1em" />
        {loadingText}
      </>
    ) : (
      defaultText
    )}
  </Button>
);
